<template>
  <b-form-group>
    <b-row>
      <b-col cols="auto" class="ml-auto px-0 mr-3 mt-2">
        <b-button 
          variant="secondary" 
          v-if="editable" 
          title="Ingredient sorteren" 
          :pressed="false"
          @click="$emit('toggle-list-mode')" 
          class="ml-3 text-dark"
        >
          <b-icon class="mr-2" icon="arrow-down-up" variant="dark" />
          {{ draggableList ? "Gereed" : "Volgorde" }}
        </b-button>
        
        <b-button 
          variant="secondary" 
          v-if="editable" 
          title="Ingredient aanmaken" 
          :pressed="false"
          @click="$emit('create-ingredient')" 
          class="ml-3 text-dark"
        >
          <b-icon class="mr-2" icon="plus-circle" variant="dark" />Add
        </b-button>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col cols="auto" class="mr-auto ml-4 px-0">
        <b-button 
          @click="$emit('toggle-selected')" 
          variant="white" 
          size="sm"
        >
          <b-icon :icon="allSelected ? 'check-square' : 'square'" style="color: #666666;"/>
        </b-button>
      </b-col>
      <b-col class="px-0 ml-0 mt-1 mb-2" style="color:#333333">
        {{ allSelected ? 'Selecteer niets' : 'Selecteer alles' }}
      </b-col>
    </b-row>
    
    <b-row>
      <b-col class="ml-4 mr-4" style="background: #DDDDDD; height: 2px"></b-col>
    </b-row>
    
    <!-- Reguliere ingrediënten lijst -->
    <b-list-group class="rounded-lg bg-light list-group-flush border-0 mt-0 mb-2 ml-0" v-if="!draggableList">
      <b-list-group-item 
        v-for="item in ingredients" 
        :class="editable ? 'd-flex bg-light border-0 py-1' : 'd-flex bg-light border-0 py-1'"
        v-cloak 
        :key="item.id"
      >
        <b-checkbox :disabled="editable" size="lg" v-model="item.selected"/>
        <b-link 
          v-b-modal.modal-center 
          v-b-modal.modal-no-backdrop 
          size="lg"
          :class="editable ? 'align-self-center text-primary text-truncate' : 'align-self-center text-dark text-truncate'" 
          :style="editable ? 'text-decoration: underline' : 'text-decoration: none'" 
          href="#"
          @click="$emit('show-ingredient-modal', item)" 
          :disabled="!editable"
        >
          {{ formatIngredient(item) }}
        </b-link>
      </b-list-group-item>
      
      <!-- Integreer de shopping list add knoppen -->
      <slot name="shopping-list-buttons"></slot>
    </b-list-group>
    
    <!-- Draggable lijst voor volgorde aanpassen -->
    <draggable 
      class="list-group" 
      tag="ul" 
      v-model="ingredientsLocal" 
      v-if="draggableList"
      v-bind="dragOptions"
      @start="$emit('drag-start')"
      @end="handleDragEnd"
    >
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <div 
          v-for="item in ingredientsLocal" 
          class="align-self-center text-primary text-truncate mt-1 py-2" 
          :key="item.id"
        >
          <b-icon class="mr-2" icon="justify" variant="primary"/>{{ formatIngredient(item) }}
        </div>
      </transition-group>
    </draggable>
  </b-form-group>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'RecipeIngredientsList',
  components: {
    draggable
  },
  props: {
    ingredients: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    draggableList: {
      type: Boolean,
      default: false
    },
    allSelected: {
      type: Boolean,
      default: false
    },
    drag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // Geen lokale kopie meer, we werken direct met de prop
    };
  },
  computed: {
    // Gebruik een computed property die direct verwijst naar de prop
    ingredientsLocal: {
      get() {
        return this.ingredients;
      },
      set(value) {
        // Emit een event wanneer de volgorde verandert
        this.$emit('update-ingredients', value);
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    formatIngredient(item) {
      if(!item || !item.ingredient || !item.ingredient.naam) {
        return 'onbekend ingredient';
      }
      
      const aantal = item.calculatedNumber || item.aantal || '';
      const eenheid = item.eenheid && item.eenheid.naam ? item.eenheid.naam : '';
      const ingredientNaam = item.ingredient.naam;
      const bewerking = item.bewerking && item.bewerking.naam ? `, ${item.bewerking.naam}` : '';
      
      return `${aantal} ${eenheid} ${ingredientNaam}${bewerking}`;
    },
    handleDragEnd() {
      this.$emit('drag-end');
      // Emit het save event na het drag end event
      this.$emit('save-ingredients', true);
    }
  }
};
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.ghost {
  opacity: 0.1;
  background: #55994B;
}
</style>
